<form [formGroup]="enrollForm" (ngSubmit)="createCustomer()" class="enroll-form">

    <!-- CUSTOMER INFO -->
    <mat-card class="section-card">
        <h3 class="section-title">
            <mat-icon class="section-icon">person</mat-icon>
            Name and Contact Information
        </h3>

        <div class="grid-3">
            <mat-form-field appearance="outline" class="search-input">
                <mat-label>First Name</mat-label>
                <input matInput placeholder="Enter First Name" formControlName="firstName">
                <mat-error class="error-msg" *ngIf="enrollForm.get('firstName')?.hasError('required')">First Name is
                    required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="search-input">
                <mat-label>Last Name</mat-label>
                <input matInput placeholder="Enter Last Name" formControlName="lastName">
                <mat-error class="error-msg" *ngIf="enrollForm.get('lastName')?.hasError('required')">Last Name is
                    required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="search-input">
                <mat-label>Account Number</mat-label>
                <input matInput placeholder="Enter Account Number" formControlName="accountNumber">
                <mat-error class="error-msg" *ngIf="enrollForm.get('accountNumber')?.hasError('required')">Account
                    Number is
                    required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="search-input">
                <mat-label>Primary Phone</mat-label>
                <input matInput placeholder="Enter Primary Phone" formControlName="primaryPhone" mask="(000)000-0000">
                <mat-error class="error-msg" *ngIf="enrollForm.get('primaryPhone')?.hasError('required')">Primary Phone
                    Number is
                    required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="search-input">
                <mat-label>Alternate Phone</mat-label>
                <input matInput placeholder="Enter Alternate Phone" formControlName="alternatePhone"
                    mask="(000)000-0000">
            </mat-form-field>

            <mat-form-field appearance="outline" class="search-input">
                <mat-label>Email</mat-label>
                <input matInput placeholder="Enter Email Address" formControlName="email">
                <mat-error class="error-msg" *ngIf="enrollForm.get('email')?.hasError('required')">Email is
                    required</mat-error>
                <mat-error *ngIf="enrollForm.get('email')?.hasError('pattern')">Please Enter a valid email
                    address</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="search-input">
                <mat-label>Customer Type</mat-label>
                <mat-select formControlName="customerType">
                    <mat-option *ngFor="let c of customerTypes" [value]="c.id">
                        {{ c.name }}
                    </mat-option>
                </mat-select>
                <mat-error class="error-msg" *ngIf="enrollForm.get('customerType')?.hasError('required')">Customer Type
                    is
                    required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="search-input">
                <mat-label>Company Name</mat-label>
                <input matInput placeholder="Enter company Name" formControlName="companyName">
            </mat-form-field>
        </div>
    </mat-card>

    <!-- SERVICE ADDRESS -->
    <mat-card class="section-card" formGroupName="serviceAddress">
        <h3 class="section-title">
            <mat-icon class="section-icon">home</mat-icon>
            Service Address
        </h3>
        <div class="grid-3">
            <mat-form-field appearance="outline" class="search-input">
                <mat-label>Street Number</mat-label>
                <input matInput placeholder="Enter Street Number" formControlName="streetNumber">
                <mat-error class="error-msg"
                    *ngIf="enrollForm.get('serviceAddress.streetNumber')?.hasError('required')">Street Number is
                    required</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="search-input">
                <mat-label>Street Name</mat-label>
                <input matInput placeholder="Enter Street Name" formControlName="streetName">
                <mat-error class="error-msg"
                    *ngIf="enrollForm.get('serviceAddress.streetName')?.hasError('required')">Street Name is
                    required</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="search-input">
                <mat-label>Apartment</mat-label>
                <input matInput placeholder="Enter Apartment Name" formControlName="apartment">
            </mat-form-field>
            <mat-form-field appearance="outline" class="search-input">
                <mat-label>City</mat-label>
                <input matInput placeholder="Enter City Name" formControlName="city">
                <mat-error class="error-msg" *ngIf="enrollForm.get('serviceAddress.city')?.hasError('required')">City
                    Name is
                    required</mat-error>

            </mat-form-field>
            <mat-form-field appearance="outline" class="search-input">
                <mat-label>State Name</mat-label>
                <mat-select formControlName="state">
                    <mat-option *ngFor="let state of usStates" [value]="state">
                        {{ state }}
                    </mat-option>
                </mat-select>
                <mat-error class="error-msg" *ngIf="enrollForm.get('serviceAddress.state')?.hasError('required')">State
                    Name is
                    required</mat-error>

            </mat-form-field>
            <mat-form-field appearance="outline" class="search-input">
                <mat-label>Zip Code</mat-label>
                <input matInput placeholder="Enter Zip Code" (keypress)="allowOnlyNumbers($event)" formControlName="zip">
                <mat-error class="error-msg" *ngIf="enrollForm.get('serviceAddress.zip')?.hasError('required')">Zip Code
                    is
                    required</mat-error>
                <mat-error *ngIf="enrollForm.get('serviceAddress.zip')?.hasError('pattern')">Please enter a valid Zip
                    Code</mat-error>
            </mat-form-field>
        </div>
    </mat-card>

    <mat-checkbox formControlName="sameAsService" color="warn" (change)="onSameAddressChange()"
        class="address-checkbox">
        Mailing address same as service address
    </mat-checkbox>

    <!-- MAILING ADDRESS -->
    <mat-card class="section-card" formGroupName="mailingAddress">
        <h3 class="section-title">
            <mat-icon class="section-icon">mail</mat-icon>
            Mailing Address
        </h3>
        <div class="grid-3">
            <mat-form-field appearance="outline" class="search-input">
                <mat-label>street Number</mat-label>
                <input matInput placeholder="Enter Street Name" formControlName="streetNumber">
                <mat-error class="error-msg"
                    *ngIf="enrollForm.get('mailingAddress.streetNumber')?.hasError('required')">Street Number is
                    required</mat-error>

            </mat-form-field>
            <mat-form-field appearance="outline" class="search-input">
                <mat-label>street Name</mat-label>
                <input matInput placeholder="Enter Street Name" formControlName="streetName">
                <mat-error class="error-msg"
                    *ngIf="enrollForm.get('mailingAddress.streetName')?.hasError('required')">Street Name is
                    required</mat-error>

            </mat-form-field>
            <mat-form-field appearance="outline" class="search-input">
                <mat-label>Apartment</mat-label>
                <input matInput placeholder="Enter Apartment Name" formControlName="apartment">
            </mat-form-field>
            <mat-form-field appearance="outline" class="search-input">
                <mat-label>City</mat-label>
                <input matInput placeholder="Enter City Name" formControlName="city">
                <mat-error class="error-msg" *ngIf="enrollForm.get('mailingAddress.city')?.hasError('required')">City is
                    required</mat-error>

            </mat-form-field>
            <mat-form-field appearance="outline" class="search-input">
                <mat-label>State Name</mat-label>
                <mat-select formControlName="state">
                    <mat-option *ngFor="let state of usStates" [value]="state">
                        {{ state }}
                    </mat-option>
                </mat-select>
                <mat-error class="error-msg" *ngIf="enrollForm.get('mailingAddress.state')?.hasError('required')">State
                    is
                    required</mat-error>

            </mat-form-field>
            <mat-form-field appearance="outline" class="search-input">
                <mat-label>Zip Code</mat-label>
                <input matInput placeholder="Enter Zip Code" (keypress)="allowOnlyNumbers($event)" formControlName="zip">
                <mat-error class="error-msg" *ngIf="enrollForm.get('mailingAddress.zip')?.hasError('required')">Zip Code
                    is
                    required</mat-error>
                <mat-error *ngIf="enrollForm.get('mailingAddress.zip')?.hasError('pattern')">Please enter a valid Zip
                    Code</mat-error>

            </mat-form-field>
        </div>
    </mat-card>

    <!-- ACTIONS -->
    <div class="action-buttons">
        <button mat-raised-button color="primary" routerLink="/search" type="button">
            Back
        </button>
        <button mat-raised-button color="primary" [disabled]="enrollForm.invalid" type="submit">
            Create
        </button>
    </div>
</form>
